import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "react-router";
import { cn } from "@/shared/lib/utils";
import { Chip } from "@/shared/ui/chip";

/** Funkció-csempe (design-rendszer 6.): 3 oszlopos rács, 10 px gap, ikon `gold` felül,
 *  felirat alatta. A kezdőlap rácsa és a mobil „Több" panel ugyanezt használja. */
export function TileGrid({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn("grid grid-cols-3 gap-2.5", className)}>{children}</div>;
}

export const TILE_CLASS =
  "flex min-h-[74px] flex-col gap-2 rounded-lg border border-line px-2.5 py-3 text-left transition-colors";

export function FunctionTile({
  to,
  label,
  icon: Icon,
  onClick,
}: {
  to: string;
  label: string;
  icon: LucideIcon;
  onClick?: () => void;
}) {
  return (
    <Link to={to} onClick={onClick} className={cn(TILE_CLASS, "hover:bg-paper")}>
      <Icon size={22} strokeWidth={1.8} className="text-gold" />
      <span className="text-[13px] font-semibold leading-tight">{label}</span>
    </Link>
  );
}

/** Még nem elérhető funkció (rendszerterv 10.3, 3–4. fázis): látszik, de nem kattintható,
 *  a jobb felső sarokban „hamarosan" chip — telefonszélességen (a csempe ~100 px) az ikon
 *  alá törik, hogy se ki ne lógjon, se az ikont ne nyomja össze. */
export function SoonTile({ label, icon: Icon }: { label: string; icon: LucideIcon }) {
  return (
    <div aria-disabled="true" className={cn(TILE_CLASS, "cursor-default")}>
      <span className="flex flex-wrap items-start justify-between gap-1">
        <Icon size={22} strokeWidth={1.8} className="shrink-0 text-gold" />
        <Chip>hamarosan</Chip>
      </span>
      <span className="text-[13px] font-semibold leading-tight">{label}</span>
    </div>
  );
}
